import { CircularProgress, styled } from '@mui/material';
import { withTheme } from '@mui/styles';
import { FC } from 'react';

interface BusyIndicatorProps {}

const StyledCircularProgress = styled(withTheme(CircularProgress))(({ theme }: any) => ({
  color: theme.palette.primary.contrastText
}));

const BusyIndicator: FC<BusyIndicatorProps> = () => (
  <StyledCircularProgress size={".7rem"} />
);

export default BusyIndicator;
